<div *transloco="let t">
  <div class="card h-100" *ngIf="!hasLicense; else withLicense">
    <div class="preview" [style]="{ 'background-image': 'url(' + product.image + ')' }">
      <div class="badge yellow">
        <img src="assets/img/iconsDefault/star.svg" class="checkmark" />
        <div class="text-wrap">{{ t('support/youInterestedIn') }}</div>
      </div>
    </div>
    <div class="card-body" [style]="{ '--border-color': product.color }">
      <div>
        <p class="heading">{{ product.title }}</p>
        <p class="mb-1">{{ product.promoDescription }}</p>
      </div>
      <div class="d-flex justify-content-center">
        <a *ngIf="product.webLink" class="btn btn-secondary action" [href]="product.webLink" target="_blank">
          {{ t('support/haveInterest') }}
        </a>
      </div>
    </div>
  </div>
  <ng-template #withLicense>
    <div class="product-row row">
      <div class="col-md-4 col-12 product-row-img" [style]="{ 'background-image': 'url(' + product.image + ')' }">
        <div class="badge">
          <img src="assets/img/iconsDefault/checkMark.svg" class="checkmark" />
          <div class="text-wrap">{{ t('support/youHaveIt') }}</div>
        </div>
      </div>
      <div class="col-md-8 col-12 product-row-body">
        <div class="heading mb-4">{{ product.title }}</div>
        <p class="mb-5">{{ product.promoDescription }}</p>
        <!-- We need to hide it for now -->
        <!-- <a *ngIf="product.webLink" class="more-btn" [href]="product.webLink" target="_blank">
          > <b>{{ t('child/moreAboutTool') }}</b>
        </a> -->
      </div>
    </div>
  </ng-template>
</div>
